export interface IVoucherSimulationAnnualResult {
    simNumber: number,
    year: number,
    growthRateConfig: number,
    growthRate: string,
    growthVariabilityConfig: number,
    growthVariability: string,
    chainStartsFv: number,
    chainStartsSv: number,
    chainStartsNdd: number,
    pairedTransplants: number,
    chainStartsTotal: number,
    chainEndsFv: number,
    chainEndsSv: number,
    chainEndsWlp: number,
    chainEndsDonor: number,
    chainEndsTotal: number,
    donorLiabilityPreviousYear: number,
    donorLiabilityNew: number,
    donorVoucherRedeemed: number,
    donorDiedWithFunctioningKidney: number,
    donorEsrdButIneligible: number,
    donorLivedPast85: number,
    donorLiabilityRemoved: number,
    donorLiabilityOutstanding: number,
    familyVoucherHolderCount: number,
    familyVoucherLiabilityPreviousYear: number,
    familyVoucherLiabilityNew: number,
    familyVoucherRedeemed: number,
    familyVoucherDiedWithFunctioningKidney: number,
    familyVoucherEsrdButIneligible: number,
    familyVoucherEsrdButVoucherNotAvailable: number,
    familyVoucherLivedPast85: number,
    familyVoucherLiabilityRemoved: number,
    familyVoucherLiabilityOutstanding: number,
    rank: number,
    liabilityTotal: number,
    coverageChainStarts: number,
    coverageEndsNeeded: number,
    coverageRatio: number,
    coverageRatioString: string
}